/*eslint-disable */

import axios from 'axios';
import commonSocket from '@/commonSocket/index.js';
import {
  mapGetters,
} from 'vuex';
import root from '@/_helpers/roots';

var $ = window.jQuery = require('jquery');


let conferenceInfoApiUrl = root.conferenceInfoApiUrl.link;
let userLeftFromWebinarApiUrl = root.userLeftFromWebinarApiUrl.link;

export default {
  name: 'jisti-video-confreness',
  components: {},
  props: [],
  data() {
    return {
      selfUserProfileDetails:null,
      apiObj:null,
      domain:process.env.VUE_APP_VIDEO_DOMAIN,
      callerRoomId:'',
      selfUserFullName:'',
      selfUserEmail:'',
      selfUserId:''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
    ]),
    getUserDetailsInfo() {
      this.selfUserProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    setIntialUserIdFun(){
      if(this.selfUserProfileDetails){
        this.selfUserFullName = this.selfUserProfileDetails.first_name + ' ' + this.selfUserProfileDetails.last_name
        this.selfUserEmail = this.selfUserProfileDetails.email
      }
    }
  },
  mounted() {
    if (!location.hash) {
      location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    }
    this.getUserDetailsInfo
    this.setIntialUserIdFun
    this.StartMeetingMethod(this.callerRoomId, this.selfUserFullName, this.selfUserEmail)
  },
  created(){
    this.callerRoomId = location.hash.substring(1);
    this.selfUserId = localStorage.getItem('LoginedUserID')
  },
  methods: {
    joinedUserInfomethod(){
      let payload = {
        meeting_id:this.callerRoomId,
        user:this.selfUserId
      }
      axios.post(conferenceInfoApiUrl, payload)
    },
    async StartMeetingMethod(roomName, dispNme, userEmail) {
      var __self = this
      const options = {
        roomName: roomName,
        width: '100%',
        height: '100%',
        parentNode: document.querySelector('#jitsi-meet-conf-container'),
        userInfo: {
          email:userEmail,
          displayName: dispNme
        },
      }
      this.apiObj = new JitsiMeetExternalAPI(this.domain, options);
      this.apiObj.on('readyToClose', () => {
        window.location.href = '/conference/user/left/room/#' + location.hash.substring(1);
      })
    },
  },
  beforeCreate: function () {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    $('body').addClass('video_conference_page')
    $('body').addClass('zisti_video_main_wrp')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('video_conference_page')
    $('body').removeClass('zisti_video_main_wrp')
    next();
  },
  watch: {
    getUserDetailsInfo() {
      return this.$store.getters.acUserDetailsStateGetters
    },
    setIntialUserIdFun(){
      if(this.selfUserProfileDetails){
        this.selfUserFullName = this.selfUserProfileDetails.first_name + ' ' + this.selfUserProfileDetails.last_name
        this.selfUserEmail = this.selfUserProfileDetails.email
      }
    }
  },
}